import client from "@/lib/api/apolloClient.ts";
import {GQL_BULK_DELETE_SLA_REPORTS, GQL_DELETE_SLA_REPORT, GQL_SLA_REPORTS} from "@/lib/queries/reports.ts";
import {MutationStatusResponse} from "@/lib/types/common.ts";

export const deleteSLAReport = async (id: number) => {
  return await client.mutate<MutationStatusResponse>({
    mutation: GQL_DELETE_SLA_REPORT,
    variables: {id},
    refetchQueries: [GQL_SLA_REPORTS],
  });
};

export const bulkDeleteSLAReports = async (ids: number[]) => {
  return await client.mutate<MutationStatusResponse>({
    mutation: GQL_BULK_DELETE_SLA_REPORTS,
    variables: {ids},
    refetchQueries: [GQL_SLA_REPORTS],
  });
};
